import { render } from "./AdminRulesOfProcedure.vue?vue&type=template&id=09a229cf&scoped=true"
import script from "./AdminRulesOfProcedure.vue?vue&type=script&lang=js"
export * from "./AdminRulesOfProcedure.vue?vue&type=script&lang=js"

import "./AdminRulesOfProcedure.vue?vue&type=style&index=0&id=09a229cf&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a229cf"]])

export default __exports__